import { render, staticRenderFns } from "./Dca.vue?vue&type=template&id=38911bea&scoped=true&"
import script from "./Dca.vue?vue&type=script&lang=js&"
export * from "./Dca.vue?vue&type=script&lang=js&"
import style0 from "./Dca.vue?vue&type=style&index=0&id=38911bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38911bea",
  null
  
)

export default component.exports